import { UniformBufferCluster } from "./UniformBufferCluster";
export function roundUp(n, align) {
    return (((n + align - 1) / align) | 0) * align;
}
export function roundDown(n, align) {
    const res = (((n + align - 1) / align) | 0) * align;
    return res > n ? res - align : res;
}
export class UniformBufferManager {
    constructor(useBigBuffer) {
        this._destroyed = false;
        this._needUpdateClusters = [];
        this._removeHoleArray = [];
        this._optimizeBufferPosArray = [];
        this._useBigBuffer = true;
        this.byteAlign = 256;
        this.clusterMaxBlock = 256;
        this.uploadThreshold = 200;
        this.removeHoleThreshold = 10;
        this.aloneBuffers = [];
        this._useBigBuffer = useBigBuffer;
        this._clustersAll = new Map();
        this._clustersCur = new Map();
    }
    _createBufferCluster(size, blockNum) {
        return new UniformBufferCluster(size, blockNum, this);
    }
    _addCluster(size, blockNum = 16) {
        const alignedSize = roundUp(size, this.byteAlign);
        const cluster = this._createBufferCluster(alignedSize, blockNum);
        const clusters = this._clustersAll.get(alignedSize);
        if (clusters) {
            clusters.push(cluster);
            cluster._sn = clusters.length - 1;
        }
        else
            this._clustersAll.set(alignedSize, [cluster]);
        this._clustersCur.set(alignedSize, cluster);
        return cluster;
    }
    startFrame() { }
    endFrame() {
    }
    getBufferAlone(size, name) {
        const alignedSize = roundUp(size, this.byteAlign);
        return this.createGPUBuffer(alignedSize, name);
    }
    removeCluster(size, sn) {
        var _a;
        const alignedSize = roundUp(size, this.byteAlign);
        if (sn < 0) {
            this._clustersAll.delete(alignedSize);
            this._clustersCur.delete(alignedSize);
            return;
        }
        const cluster_sn = (_a = this._clustersCur.get(alignedSize)) === null || _a === void 0 ? void 0 : _a._sn;
        const clusters = this._clustersAll.get(alignedSize);
        if (clusters.length > sn) {
            clusters.splice(sn, 1);
            if (clusters.length === 0) {
                this._clustersAll.delete(alignedSize);
                this._clustersCur.delete(alignedSize);
                return;
            }
            else {
                for (let i = sn; i < clusters.length; i++)
                    clusters[i]._sn--;
            }
        }
        else
            return;
        if (cluster_sn !== undefined
            && cluster_sn === sn) {
            let usedNumMax = -1, usedNum = -1, index = -1;
            for (let i = clusters.length - 1; i > -1; i--) {
                usedNum = clusters[i].usedNum;
                if (usedNum > usedNumMax
                    && usedNum < this.clusterMaxBlock) {
                    index = i;
                    usedNumMax = usedNum;
                }
            }
            if (index >= 0)
                this._clustersCur.set(alignedSize, clusters[index]);
            else
                this._clustersCur.delete(alignedSize);
        }
    }
    getBlock(size, user) {
        const alignedSize = roundUp(size, this.byteAlign);
        let cluster = this._clustersCur.get(alignedSize);
        if (!cluster)
            return this._addCluster(alignedSize).getBlock(size, user);
        if (cluster.usedNum < this.clusterMaxBlock)
            return cluster.getBlock(size, user);
        cluster = null;
        const clusters = this._clustersAll.get(alignedSize);
        let usedNumMax = -1, usedNum = -1, index = -1;
        for (let i = clusters.length - 1; i > 0; i--) {
            usedNum = clusters[i].usedNum;
            if (usedNum > usedNumMax
                && usedNum < this.clusterMaxBlock) {
                index = i;
                usedNumMax = usedNum;
            }
        }
        if (index >= 0) {
            cluster = clusters[index];
            this._clustersCur.set(alignedSize, cluster);
        }
        else
            this._clustersCur.delete(alignedSize);
        if (cluster)
            return cluster.getBlock(size, user);
        return this._addCluster(alignedSize).getBlock(size, user);
    }
    freeBlock(bb) {
        const cluster = bb.cluster;
        if (cluster) {
            if (cluster.freeBlock(bb)) {
                if (cluster.usedNum === 0)
                    this.removeCluster(cluster._blockSize, cluster._sn);
                return true;
            }
            return false;
        }
        return false;
    }
    upload() {
        if (this._useBigBuffer) {
            let t;
            let cluster;
            for (let i = this._needUpdateClusters.length - 1; i > -1; i--) {
                cluster = this._needUpdateClusters[i];
                cluster.upload();
                cluster._inManagerUpdateArray = false;
            }
            this._needUpdateClusters.length = 0;
        }
    }
    _addUpdateArray(cluster) {
        if (!cluster._inManagerUpdateArray) {
            this._needUpdateClusters.push(cluster);
            cluster._inManagerUpdateArray = true;
        }
    }
    _addRemoveHoleCluster(cluster) {
        if (this._removeHoleArray.indexOf(cluster) === -1)
            this._removeHoleArray.push(cluster);
    }
    _addOptimizeBufferPos(cluster) {
        if (this._optimizeBufferPosArray.indexOf(cluster) === -1)
            this._optimizeBufferPosArray.push(cluster);
    }
    clear() {
        this._clustersAll.forEach(clusters => {
            for (let i = clusters.length - 1; i > -1; i--)
                clusters[i].clear();
        });
    }
    destroy() {
        if (!this._destroyed) {
            this.clear();
            this._clustersAll.clear();
            this._clustersCur.clear();
            this._destroyed = true;
            return true;
        }
        console.warn('UniformBufferManager: object alreay destroyed!');
        return false;
    }
    createGPUBuffer(size, name, data) {
    }
    writeBuffer(buffer, data, offset, size) {
    }
    statisGPUMemory(bytes) {
    }
}
